import React, { useEffect, useState } from 'react';
import NewForm from 'components/NewForm';
import States from "json/brazil-states.json";
import { useTranslation } from 'react-i18next';
// import BM from "json/budget-model.json";

export default function CompanyData(props?:any){
  // const [ data, setData ] = useState<any>({});
  const [ state, setState ] = useState<any[]>([]);
  // const [ budgetModel, setBudgetModel ] = useState<any[]>([]);

  const { t } = useTranslation();

  useEffect(()=>{
    let state:any[] = States;
    setState(state.map(item=>{
      return {value:item.sigla,name:item.sigla};
    }));

    // let bm:any[] = BM;
    // setBudgetModel(bm.map(item=>{
    //   return {value:item.id,name:item.name};
    // }));
  },[]);

  return (
    <>
      <NewForm title={t("company:form:card:brand")}>
        <NewForm.Input title={t("company:form:labels:name")} md="4" name="name" state={{model:props.data, setModel:props.setData}}/>
        <NewForm.Input title={t("company:form:labels:alias")} md="4" name="alias" state={{model:props.data, setModel:props.setData}}/>
        <NewForm.InputNumber title={t("company:form:labels:document")} md="4" name="document" mask="{2}.{3}.{3}/{4}-{2}" state={{model:props.data, setModel:props.setData}}/>
        <NewForm.Input title={t("company:form:labels:internal_code")} md="4" name="internal_code" state={{model:props.data, setModel:props.setData}}/>
        {/* <NewForm.Select title="Modelo de Verba" md="4" name="fund_model" state={{model:props.data, setModel:props.setData}} options={[{value:"",name:"Selecione"},...budgetModel]}/> */}
        <NewForm.Input title={t("company:form:labels:business_unit")} md="4" name="business_unity" state={{model:props.data, setModel:props.setData}}/>
        {/* <NewForm.Input title="Segmento" md="4" name="segment" state={{model:props.data, setModel:props.setData}}/> */}
      </NewForm>
      <NewForm title={t("company:form:card:address")} className="mt-4">
        <NewForm.InputNumber title={t("company:form:labels:postal_code")} md="4" name="address_zipcode" mask="{5}-{3}" state={{model:props.data, setModel:props.setData}}/>
        <NewForm.Input title={t("company:form:labels:address")} md="4" name="address" state={{model:props.data, setModel:props.setData}}/>
        <NewForm.InputNumber title={t("company:form:labels:number")} md="4" name="address_number" state={{model:props.data, setModel:props.setData}}/>
        <NewForm.Input title={t("company:form:labels:complement")} md="4" name="address_complement" state={{model:props.data, setModel:props.setData}}/>
        <NewForm.Input title={t("company:form:labels:city")} md="4" name="address_city" state={{model:props.data, setModel:props.setData}}/>
        <NewForm.Select title={t("company:form:labels:state")} md="4" name="address_state" state={{model:props.data, setModel:props.setData}} options={[{value:"",name:"Selecione"},...state]}/>
      </NewForm>
    </>
  );
}